import _ from "lodash";
import { useEffect, useState } from "react";
import { Container } from "./style/SummaryTable.styled";
import TableBoardFieldView from "./view/TableBoardField.view";
import TableFieldView from "./view/TableField.view";
import UnsalesItemViewSelectorModalComponent from "./modal/unsales-item-view-selector/UnsalesItemViewSelector.component";
import useRouterHookV2 from "../../../../../hooks/router/useRouterHookV2";
import { getEndDate, getStartDate, setPlusDate } from "../../../../../utils/dateFormatUtils";

export default function SummaryTableComponent (props) {
    const router = useRouterHookV2();

    const [tableData, setTableData] = useState(null);
    const [totalSumData, setTotalSumData] = useState(null);
    const [unsalesItemViewModalOpen, setUnsalesItemViewModalOpen] = useState(false);
    const [unsalesItemSearchPeriod, setUnsalesItemSearchPeriod] = useState(null);

    useEffect(() => {
        if(!props.analysis) {
            return;
        }

        handleActionCreateTotalSumData();
        handleActionCreateTableData();
    }, [props.analysis, props.checkedExcludedDeliveryChargeSwitch])

    const handleActionCreateTotalSumData = () => {
        let totalSumData = {
            datetime: '전체',
            orderRegistration: 0,
            orderUnit: 0,
            orderPayAmount: 0,
            salesRegistration: 0,
            salesUnit: 0,
            salesPayAmount: 0,
            unsalesRegistration: 0,
            unsalesUnit: 0,
            unsalesPayAmount: 0
        };

        props.analysis.forEach(r => {
            let viewSalesPayAmount = props.checkedExcludedDeliveryChargeSwitch ? r.excludedDeliveryChargeSalesPayAmount : r.salesPayAmount;
            let viewOrderPayAmount = props.checkedExcludedDeliveryChargeSwitch ? r.excludedDeliveryChargeOrderPayAmount : r.orderPayAmount;
            
            totalSumData = {
                ...totalSumData,
                orderRegistration: totalSumData.orderRegistration + r.orderRegistration,
                orderUnit: totalSumData.orderUnit + r.orderUnit,
                orderPayAmount: totalSumData.orderPayAmount + viewOrderPayAmount,
                salesRegistration: totalSumData.salesRegistration + r.salesRegistration,
                salesUnit: totalSumData.salesUnit + r.salesUnit,
                salesPayAmount: totalSumData.salesPayAmount + viewSalesPayAmount
            }
        });

        totalSumData = {
            ...totalSumData,
            unsalesRegistration: totalSumData.orderRegistration - totalSumData.salesRegistration,
            unsalesUnit: totalSumData.orderUnit - totalSumData.salesUnit,
            unsalesPayAmount: totalSumData.orderPayAmount - totalSumData.salesPayAmount
        }
        
        setTotalSumData(totalSumData);
    }

    const handleActionCreateTableData = () => {
        let tableData = props.analysis.map(r => {
            let viewSalesPayAmount = props.checkedExcludedDeliveryChargeSwitch ? r.excludedDeliveryChargeSalesPayAmount : r.salesPayAmount;
            let viewOrderPayAmount = props.checkedExcludedDeliveryChargeSwitch ? r.excludedDeliveryChargeOrderPayAmount : r.orderPayAmount;

            return {
                ...r,
                unsalesRegistration: r.orderRegistration - r.salesRegistration,
                unsalesUnit: r.orderUnit - r.salesUnit,
                unsalesPayAmount: viewOrderPayAmount - viewSalesPayAmount
            }
        });

        let viewPayAmountField = props.checkedExcludedDeliveryChargeSwitch ? 'excludedDeliveryChargeSalesPayAmount' : 'salesPayAmount';
        tableData = _.orderBy(tableData, viewPayAmountField, 'desc');
        setTableData(tableData);
    }

    const handleOpenUnsalesItemViewModal = (e, datetime) => {
        e.stopPropagation();
        e.preventDefault();

        let searchStartDate = new Date(datetime);
        let searchEndDate = new Date(datetime);

        if(datetime === '전체') {
            searchStartDate = setPlusDate(new Date(), 0, 0, -13);
            searchEndDate = new Date();

            if (router.query.startDate && router.query.endDate) {
                searchStartDate = new Date(router.query.startDate);
                searchEndDate = new Date(router.query.endDate);
            }
        }

        setUnsalesItemSearchPeriod({
            startDate: getStartDate(searchStartDate),
            endDate: getEndDate(searchEndDate)
        });

        setUnsalesItemViewModalOpen(true);
    }

    const handleCloseUnsalesItemViewModal = () => {
        setUnsalesItemViewModalOpen(false);
    }
    
    return (
        <>
            <Container>
                <TableBoardFieldView />

                <TableFieldView
                    isTotalAnalysisLoading={props.isTotalAnalysisLoading}
                    totalSumData={totalSumData}
                    tableData={tableData}
                    checkedExcludedDeliveryChargeSwitch={props.checkedExcludedDeliveryChargeSwitch}
                    onOpenUnsalesItemViewModal={handleOpenUnsalesItemViewModal}
                />
            </Container>
        
            {unsalesItemViewModalOpen &&
                <UnsalesItemViewSelectorModalComponent
                    modalOpen={unsalesItemViewModalOpen}
                    unsalesItemSearchPeriod={unsalesItemSearchPeriod}

                    onActionCloseModal={handleCloseUnsalesItemViewModal}
                />
            }
        </>
    )
}